import { BackendProductUpsertOperationNameEnum } from "@credit-acceptance/step6-bff-client";

/** Sentinel "not listed" option for the Form Number dropdown — see `useVendorFormOptions`. */
export const MyFormNotListedOption = "My Form Not Listed" as string;

/**
 * Normalizes a Contract Worksheet Service product name (`contractObp[].selectedProductName`,
 * free-text, lowercase-keyed) to the BFF's official product name — same convention as
 * `other-backend-products`' `ContractToBackendNamesMap` (`apps/other-backend-products/src/constants/productConstants.ts`),
 * duplicated here rather than imported since the two apps are separate Vite bundles.
 */
export const ContractToBackendNamesMap: Record<string, BackendProductUpsertOperationNameEnum> = {
  maintenance: BackendProductUpsertOperationNameEnum.Maintenance,
  "tire and wheel": BackendProductUpsertOperationNameEnum.TireAndWheel,
  "key replacement": BackendProductUpsertOperationNameEnum.KeyReplacement,
  "bundled products": BackendProductUpsertOperationNameEnum.BundledProducts,
  "appearance repair services": BackendProductUpsertOperationNameEnum.AppearanceRepairServices,
  "appearance protection": BackendProductUpsertOperationNameEnum.AppearanceProtection,
};

export const ProductDisplayNameMap: Record<BackendProductUpsertOperationNameEnum, string> = {
  [BackendProductUpsertOperationNameEnum.Maintenance]: "Maintenance",
  [BackendProductUpsertOperationNameEnum.TireAndWheel]: "Tire and Wheel",
  [BackendProductUpsertOperationNameEnum.KeyReplacement]: "Key Replacement",
  [BackendProductUpsertOperationNameEnum.AppearanceRepairServices]: "Appearance Repair Services",
  [BackendProductUpsertOperationNameEnum.AppearanceProtection]: "Appearance Protection",
  [BackendProductUpsertOperationNameEnum.BundledProducts]: "Bundled Products",
};
